module.exports = __webpack_public_path__ + "static/media/module_firebase.a3f31b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_firebase.png
// module id = ./src/resources/images/modules/module_firebase.png
// module chunks = 0